import { cdnUrl } from '../../../common/constants/s3ImageUrls'

export const getShopPageHeroImage = (resolution: 'desktop' | 'mobile') =>
  cdnUrl(`/shop/shop-page-main-hero-${resolution === 'mobile' ? 'mobile' : 'desktop'}.webp`)
